import store from '@/store'

/**
 * 获取餐费标准
 * @returns Array<Number> - 依次对应早中晚餐费
 */
export function useStandFee() {
    const userInfo = store.state.user
    const { code } = userInfo.company || {}
    const companyFee = [13, 25, 12] // 公司级餐费标准
    const subFee = [6, 15, 9] // 分公司及项目部餐费标准
    let result = [0, 0, 0]
    switch(code) {
        case 'CO': 
            result = companyFee
            break
        case 'BC':
            result =  subFee
            break
        case 'PD':
            result = subFee
            break
        default:
            break
    }
    return result
}